// extracted by mini-css-extract-plugin
export default {"info":"style_info__ZVP9M","info__col":"style_info__col__25Xub"};